/**
 * API updateUserInfo returns flat Mongo-style keys, e.g.
 * { "Settings.Feed.HideOfficialDoitify": true }.
 * Redux user objects use nested Settings.Feed — expand and deep-merge.
 */

function deepMergeSettings(a = {}, b = {}) {
  return {
    ...a,
    ...b,
    Notifs: b.Notifs ? { ...a.Notifs, ...b.Notifs } : a.Notifs,
    Feed: b.Feed ? { ...a.Feed, ...b.Feed } : a.Feed,
    Privacy: b.Privacy ? { ...a.Privacy, ...b.Privacy } : a.Privacy,
  };
}

function deepMergeUser(prev, delta) {
  const out = { ...prev };
  for (const key of Object.keys(delta)) {
    const v = delta[key];
    if (v === undefined) continue;
    if (
      key === "Settings" &&
      prev[key] &&
      typeof prev[key] === "object" &&
      typeof v === "object" &&
      !Array.isArray(v)
    ) {
      out.Settings = deepMergeSettings(prev.Settings, v);
    } else if (
      typeof v === "object" &&
      v !== null &&
      !Array.isArray(v) &&
      prev[key] &&
      typeof prev[key] === "object" &&
      !Array.isArray(prev[key])
    ) {
      out[key] = { ...prev[key], ...v };
    } else {
      out[key] = v;
    }
  }
  return out;
}

/** Turn { "Settings.Feed.HideOfficialDoitify": true } into nested objects. */
export function expandFlatUserUpdates(flat) {
  const out = {};
  if (!flat || typeof flat !== "object") return out;
  for (const [key, value] of Object.entries(flat)) {
    if (value === undefined) continue;
    if (key.includes(".")) {
      const parts = key.split(".");
      let target = out;
      for (let i = 0; i < parts.length - 1; i++) {
        const p = parts[i];
        if (target[p] && typeof target[p] !== "object") {
          target[p] = {};
        }
        target[p] = target[p] || {};
        target = target[p];
      }
      target[parts[parts.length - 1]] = value;
    } else {
      out[key] = value;
    }
  }
  return out;
}

/** Merge API flat patch into existing user shape (nested Settings). */
export function mergeUserPatch(prevUser, flatPatch) {
  if (!flatPatch || typeof flatPatch !== "object") return prevUser;
  const nested = expandFlatUserUpdates(flatPatch);
  if (!prevUser) return nested;
  return deepMergeUser(prevUser, nested);
}
